import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import Box from '@material-ui/core/Box';
import MuiAlert from '@material-ui/lab/Alert';
import {
    closeNotification,
    focusIn,
    focusOut,
    selectVisibleNotifications,
} from './features/notifications/notificationsSlice';

const useStyles = makeStyles(({ spacing, breakpoints, zIndex }) => ({
    notificationArea: {
        position: 'fixed',
        alignItems: 'end',
        bottom: 0,
        right: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: spacing(1),
        zIndex: zIndex.modal - 1,
        padding: spacing(1),
        'html[dir=rtl] &': {
            left: 0,
            right: 'unset',
        },
        [`@media (max-width: ${breakpoints.values.md}px)`]: {
            top: 0,
            bottom: 'unset',
            left: 0,
            right: 'unset',
            alignItems: 'start',
            flexDirection: 'column-reverse',
            'html[dir=rtl] &': {
                left: 'unset',
                right: 0,
            },
        },
    },
    notification: {
        width: 'fit-content',
    },
    truncateText: {
        display: 'block',
        maxWidth: 'calc(100vw - 10rem)',
        overflow: 'hidden',
        '-webkit-box-orient': 'vertical',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        '-webkit-line-clamp': '1',
    },
}));

function Notifications({ notifications, focusIn, focusOut }) {
    const classes = useStyles();
    return (
        <Box className={classes.notificationArea}>
            {notifications.map(notification => (
                <MuiAlert
                    className={classes.notification}
                    onMouseEnter={() => focusIn(notification.notificationId)}
                    onMouseLeave={() => focusOut(notification.notificationId)}
                    key={notification.notificationId}
                    severity={notification.severity}
                >
                    <span className={classes.truncateText}>
                        <FormattedMessage
                            id={notification.messageId}
                            values={notification.values}
                        />
                    </span>
                </MuiAlert>
            ))}
        </Box>
    );
}

Notifications.propTypes = {
    focusIn: PropTypes.func,
    focusOut: PropTypes.func,
    notifications: PropTypes.object,
};

const mapStateToProps = state => ({
    notifications: selectVisibleNotifications(state),
});

const mapDispatchToProps = {
    onClose: closeNotification,
    focusIn: focusIn,
    focusOut: focusOut,
};

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);
